import React from 'react';

export default function StatCard({ title, value, subtitle }) {
    return (
        <div className="dashboard-new-card">
            {title ? <h3>{title}</h3> : null}
            <div style={{ fontSize: '1.5rem', fontWeight: 700 }}>{value}</div>
            {subtitle ? <div style={{ color: '#94a3b8', marginTop: '0.25rem' }}>{subtitle}</div> : null}
        </div>
    );
}


